<template>

  <v-card color="grey lighten-5" flat class="report-table-card">

    <div class="report-topbar">

      <div class="report-meta">

        <span class="meta-item">

          {{ uiText("Report-Visible-Columns", "Görünen Kolon") }}:

          <strong>{{ visibleColumns.length }} / {{ internalHeaders.length }}</strong>

        </span>

        <span class="meta-item">

          {{ uiText("Report-Records", "Kayıt") }}:

          <strong>{{ filteredItems.length }} / {{ normalizedItems.length }}</strong>

        </span>

      </div>

      <div class="report-actions">

        <v-text-field

          v-if="showSearch"

          flat

          solo-inverted

          hide-details

          v-model="internalSearch"

          :label="searchLabel"

          append-icon="search"

          class="toolbar-search"

        ></v-text-field>

        <slot name="actions"></slot>

        <v-btn color="info" @click="columnDialog = true">

          <v-icon left>view_column</v-icon>

          {{ uiText("Report-Columns", "Kolonlar") }}

        </v-btn>

        <v-btn

          v-if="showFrontendExport"

          color="success"

          @click="openExportLanguageDialog('excel')"

        >

          <v-icon left>file_download</v-icon>

          Excel

        </v-btn>

        <v-btn

          v-if="showFrontendExport"

          color="blue-grey"

          dark

          @click="openExportLanguageDialog('html')"

        >

          <v-icon left>language</v-icon>

          HTML

        </v-btn>

      </div>

    </div>

    <v-dialog v-model="columnDialog" max-width="760px" scrollable>

      <v-card>

        <v-card-title class="headline">

          {{ uiText("Report-Columns", "Kolonlar") }}

        </v-card-title>

        <v-divider></v-divider>

        <v-card-text class="pt-3">

          <div class="column-dialog-note">

            {{ uiText("Report-Column-Dialog-Note", "Kolon sırasını sürükle bırak ile değiştir, görünürlüğü açıp kapat.") }}

          </div>

          <div class="column-list">

            <div

              v-for="(column, index) in internalHeaders"

              :key="column.value"

              class="column-item"

              draggable="true"

              @dragstart="onColumnDragStart(index)"

              @dragover.prevent

              @drop="onColumnDrop(index)"

            >

              <div class="column-item-left">

                <v-icon small class="mr-2 drag-handle">drag_indicator</v-icon>

                <span class="column-title">{{ column.text }}</span>

              </div>

              <v-switch

                v-model="column.visible"

                color="info"

                hide-details

                class="ma-0 pa-0 column-switch"

                @change="onColumnVisibilityChange"

              ></v-switch>

            </div>

          </div>

        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>

          <v-btn flat color="warning" @click="resetColumns">

            {{ uiText("Report-Default-Columns", "Varsayılan Kolonlar") }}

          </v-btn>

          <v-spacer></v-spacer>

          <v-btn flat color="blue darken-1" @click="columnDialog = false">

            {{ $t("Close") }}

          </v-btn>

        </v-card-actions>

      </v-card>

    </v-dialog>

    <v-dialog v-model="exportLanguageDialog" persistent max-width="460px">

      <v-card>

        <v-card-title class="headline">

          {{ pendingExportType === "html" ? "HTML" : "Excel" }} - {{ exportUiText("Report-Export-Language", "Dışa Aktarım Dili") }}

        </v-card-title>

        <v-divider></v-divider>

        <v-card-text>

          <div class="export-language-note">{{ exportUiText("Report-Select-Export-Language", "İndirilecek dosyanın dilini seçiniz.") }}</div>

          <v-select

            :items="exportLanguages"

            v-model="exportLanguage"

            item-text="title"

            item-value="locale"

            hide-details

          ></v-select>

        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>

          <v-spacer></v-spacer>

          <v-btn flat @click="closeExportLanguageDialog">{{ exportUiText("cancel_button", "İptal") }}</v-btn>

          <v-btn color="info" @click="confirmExportLanguage">

            {{ pendingExportType === "html" ? exportUiText("Report-Download-HTML", "HTML İndir") : exportUiText("Report-Download-Excel", "Excel İndir") }}

          </v-btn>

        </v-card-actions>

      </v-card>

    </v-dialog>

    <!-- Excel / HTML hazırlanırken kullanıcı işlem durumunu görür. -->
    <v-dialog v-model="exportProcessing" persistent max-width="520px">
      <v-card class="export-processing-card">
        <v-card-title class="headline export-processing-title">
          {{ exportUiText("Report-Preparing-Export", "Rapor hazırlanıyor") }}
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text class="export-processing-body">
          <div class="export-processing-icon">
            <v-progress-circular
              :rotate="-90"
              :size="48"
              :width="4"
              :value="exportProgress"
              color="info"
            >
              {{ exportProgress }}
            </v-progress-circular>
          </div>
          <div class="export-processing-content">
            <div class="export-processing-main-text">
              {{ pendingExportType === "html"
                ? exportUiText("Report-Preparing-HTML", "Seçtiğiniz dil ayarlanıyor ve HTML raporu hazırlanıyor...")
                : exportUiText("Report-Preparing-Excel", "Seçtiğiniz dil ayarlanıyor ve Excel dosyası hazırlanıyor...") }}
            </div>
            <div class="export-processing-note">
              {{ exportUiText("Report-Do-Not-Close-While-Preparing", "İndirme başlayana kadar lütfen sayfayı yenilemeyiniz veya kapatmayınız.") }}
            </div>
            <div class="export-progress-row">
              <v-progress-linear
                :value="exportProgress"
                color="info"
                height="8"
                class="export-processing-bar"
              ></v-progress-linear>

              <div class="export-progress-percent">
                {{ exportProgress }}%
              </div>
            </div>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>

    <div class="table-stage">

      <div

        class="report-scroll-top"

        ref="reportScrollTop"

        @scroll="syncTopScroll"

      >

        <div

          class="report-scroll-inner"

          ref="reportScrollInner"

        ></div>

      </div>

      <div

        ref="tableWrapper"

        class="table-wrapper"

        @scroll="syncBottomScroll"

      >

        <table ref="reportRealTable" class="modern-report-table">

          <colgroup>

            <col

              v-for="column in visibleColumns"

              :key="'col-' + column.value"

              :style="getColStyle(column)"

            />

          </colgroup>

          <thead>

            <tr>

              <th

                v-for="(header, index) in visibleColumns"

                :key="header.value"

                :class="[

                  'column-header',

                  header.align ? 'text-xs-' + header.align : 'text-xs-left',

                  {

                    sortable: header.sortable,

                    dragging: draggedHeaderIndex === index

                  }

                ]"

                :draggable="!isResizing"

                @dragstart="onHeaderDragStart($event, index)"

                @dragover.prevent

                @drop="onHeaderDrop(index)"

              >

                <div

                  class="header-content"

                  @click="onHeaderClick($event, header)"

                >

                  <div class="header-left">

                    <v-icon small class="drag-handle header-drag-handle">drag_indicator</v-icon>

                    <span class="header-text">{{ header.text }}</span>

                  </div>

                </div>

                <div v-if="header.sortable" class="sort-icons">

                  <v-icon small v-if="sortBy === header.value && sortDesc">arrow_downward</v-icon>

                  <v-icon small v-else-if="sortBy === header.value && !sortDesc">arrow_upward</v-icon>

                  <v-icon small v-else>unfold_more</v-icon>

                </div>

                <div

                  class="column-resizer"

                  @mousedown.stop.prevent="startResize($event, header)"

                  @click.stop.prevent

                ></div>

              </th>

            </tr>

          </thead>

          <tbody v-if="paginatedItems.length">

            <tr

              v-for="(item, rowIndex) in paginatedItems"

              :key="getRowKey(item, rowIndex)"

              :class="getRowClass(item)"

            >

              <td

                v-for="column in visibleColumns"

                :key="column.value"

                :class="[

                  'report-cell',

                  column.align ? 'text-xs-' + column.align : 'text-xs-left'

                ]"

              >

                <template v-if="$scopedSlots.cell">

                  <slot

                    name="cell"

                    :item="item"

                    :column="column"

                    :value="formatCellValue(item, column)"

                  >

                    {{ formatCellValue(item, column) }}

                  </slot>

                </template>

                <template v-else>

                  <div class="cell-content">

                    {{ formatCellValue(item, column) }}

                  </div>

                </template>

              </td>

            </tr>

          </tbody>

          <tbody v-else>

            <tr>

              <td :colspan="Math.max(visibleColumns.length, 1)" class="empty-state-cell">

                <div

                  v-if="hasSearched && !loading && filteredItems.length === 0"

                  class="empty-state"

                >

                  {{ uiText("Report-No-Records", "Kayıt bulunamadı") }}

                </div>

              </td>

            </tr>

          </tbody>

        </table>

      </div>

    </div>

    <div class="custom-pagination">

      <div class="pagination-left">

        <span>{{ uiText("Report-Rows-Per-Page", "Sayfa başına") }}:</span>

        <v-select

          :items="rowsPerPageItems"

          v-model="rowsPerPage"

          hide-details

          solo

          flat

          class="rows-per-page-select"

        ></v-select>

      </div>

      <div class="pagination-center">

        {{ uiText("Report-Total-Records", "Toplam kayıt") }}: <strong>{{ filteredItems.length }}</strong>

      </div>

      <div class="pagination-right">

        <v-btn icon :disabled="page <= 1" @click="goToFirstPage">

          <v-icon>first_page</v-icon>

        </v-btn>

        <v-btn icon :disabled="page <= 1" @click="page = page - 1">

          <v-icon>chevron_left</v-icon>

        </v-btn>

        <span class="page-info">

          {{ uiText("Report-Page", "Sayfa") }} {{ safePage }} / {{ totalPages }}

        </span>

        <v-btn icon :disabled="page >= totalPages" @click="page = page + 1">

          <v-icon>chevron_right</v-icon>

        </v-btn>

        <v-btn icon :disabled="page >= totalPages" @click="goToLastPage">

          <v-icon>last_page</v-icon>

        </v-btn>

      </div>

    </div>

  </v-card>

</template>

<script>

import helpers from "@/components/app/customcomp/helpers.js";

import * as XLSX from "xlsx-js-style";

import trMessages from "@/lang/tr.json";

import enMessages from "@/lang/en.json";

import frMessages from "@/lang/fr.json";

import deMessages from "@/lang/de.json";

import deCMessages from "@/lang/deC.json";

export default {

  name: "ReportTable",

  props: {

    headers: {

      type: Array,

      default: function () {

        return [];

      }

    },

    items: {

      type: Array,

      default: function () {

        return [];

      }

    },

    storageKey: {

      type: String,

      default: "report_table_default"

    },

    loading: {

      type: Boolean,

      default: false

    },

    hasSearched: {

      type: Boolean,

      default: false

    },

    searchLabel: {

      type: String,

      default: "Ara"

    },

    showSearch: {

      type: Boolean,

      default: true

    },

    showFrontendExport: {

      type: Boolean,

      default: true

    },

    rowsPerPageItems: {

      type: Array,

      default: function () {

        return [10, 20, 50, 100, 250, 500, 1000];

      }

    },

    rowClassFn: {

      type: Function,

      default: null

    },

    excelSummaryConfig: {

      type: Object,

      default: null

    },

    exportTitle: {

      type: String,

      default: ""

    },

    exportMetaItems: {

      type: Array,

      default: function () {

        return [];

      }

    },

    exportSummaryCards: {

      type: Array,

      default: function () {

        return [];

      }

    }

  },

  data() {

    return {

      internalHeaders: [],

      internalSearch: "",

      columnDialog: false,

      exportLanguageDialog: false,

      exportProcessing: false,
      exportProgress: 0,

      /*
       * Dışa aktarım sırasında her hücre için binlerce dil anahtarını
       * tekrar tekrar taramamak adına önbellek kullanılır.
       * Büyük raporlarda tarayıcının "Sayfa Yanıt Vermiyor" demesinin
       * ana sebebi bu tekrarlı sözlük taramasıydı.
       */
      exportTranslationCache: Object.create(null),
      exportReverseMessageCache: Object.create(null),
      exportCompositeCandidateCache: Object.create(null),

      exportLanguage: "en",

      pendingExportType: "excel",

      sortBy: "",

      sortDesc: false,

      page: 1,

      rowsPerPage: 20,

      draggedColumnIndex: null,

      draggedHeaderIndex: null,

      defaultHeadersSnapshot: [],

      isResizing: false,

      resizeState: {

        active: false,

        columnValue: "",

        startX: 0,

        startWidth: 0

      }

    };

  },

  computed: {

    exportLanguages() {

      return [

        { locale: "tr", title: this.uiText("Report-Turkish", "Türkçe") },

        { locale: "en", title: this.uiText("Report-English", "English") },

        { locale: "fr", title: this.uiText("Report-French", "Français") },

        { locale: "de", title: this.uiText("Report-German", "Deutsch") }

      ];

    },

    normalizedItems() {

      return Array.isArray(this.items) ? this.items : [];

    },

    visibleColumns() {

      return this.internalHeaders.filter(function (x) {

        return x.visible;

      });

    },

    filteredItems() {

      const vm = this;

      let list = this.normalizedItems.slice();

      if (this.internalSearch && String(this.internalSearch).trim() !== "") {

        const keyword = String(this.internalSearch).toLocaleLowerCase("tr-TR").trim();

        list = list.filter(function (item) {

          return vm.internalHeaders.some(function (column) {

            const raw = vm.getExportValue(item, column);

            return String(raw || "")

              .toLocaleLowerCase("tr-TR")

              .indexOf(keyword) > -1;

          });

        });

      }

      if (this.sortBy) {

        list.sort(this.sortFunction);

      }

      return list;

    },

    totalPages() {

      if (!this.filteredItems.length) {

        return 1;

      }

      return Math.max(1, Math.ceil(this.filteredItems.length / this.rowsPerPage));

    },

    safePage() {

      return Math.min(this.page, this.totalPages);

    },

    paginatedItems() {

      const start = (this.safePage - 1) * this.rowsPerPage;

      const end = start + this.rowsPerPage;

      return this.filteredItems.slice(start, end);

    }

  },

  watch: {

    headers: {

      handler(newVal) {

        this.setupHeaders(newVal);

      },

      deep: true,

      immediate: true

    },

    filteredItems() {

      if (this.page > this.totalPages) {

        this.page = this.totalPages;

      }

      this.$nextTick(() => {

        this.updateTopScrollbar();

      });

    },

    rowsPerPage() {

      this.page = 1;

      this.$nextTick(() => {

        this.updateTopScrollbar();

      });

    },

    internalSearch(val) {

      this.$emit("search-change", val);

    },

    paginatedItems() {

      this.$nextTick(() => {

        this.updateTopScrollbar();

      });

    },

    visibleColumns() {

      this.$nextTick(() => {

        this.updateTopScrollbar();

      });

    },

    columnDialog(val) {

      if (!val) {

        this.$nextTick(() => {

          this.updateTopScrollbar();

        });

      }

    }

  },

  mounted() {

    this.$nextTick(() => {

      this.updateTopScrollbar();

    });

    window.addEventListener("resize", this.updateTopScrollbar);

    document.addEventListener("mousemove", this.onResizeMouseMove);

    document.addEventListener("mouseup", this.stopResize);

  },

  beforeDestroy() {

    window.removeEventListener("resize", this.updateTopScrollbar);

    document.removeEventListener("mousemove", this.onResizeMouseMove);

    document.removeEventListener("mouseup", this.stopResize);

  },

  methods: {

    uiText(key, fallback) {

      try {

        const translated = this.$t ? this.$t(key) : key;

        if (translated !== null && translated !== undefined && String(translated) !== key) {

          return translated;

        }

      } catch (e) {}

      return fallback || key;

    },

    exportUiText(key, fallback) {
      /*
       * Excel / HTML dışa aktarım penceresindeki metinler,
       * kullanıcının dropdown'dan seçtiği export diline göre değişir.
       */
      try {
        const locale = this.normalizeExportLanguage(
          this.exportLanguage ||
          localStorage.getItem("lang") ||
          (this.$i18n ? this.$i18n.locale : "en") ||
          "en"
        );

        const messages = this.getExportMessages(locale);

        if (
          messages &&
          Object.prototype.hasOwnProperty.call(messages, key) &&
          messages[key] !== null &&
          messages[key] !== undefined &&
          String(messages[key]).trim() !== ""
        ) {
          return messages[key];
        }
      } catch (e) {
        // Mevcut ekranı bozma; fallback kullan.
      }

      return fallback || key;
    },

    getCommonExportFallback(lang) {

      const locale = this.normalizeExportLanguage(lang);

      const common = {

        tr: {

          "Report-Visible-Columns": "Görünen Kolon",

          "Report-Records": "Kayıt",

          "Report-Columns": "Kolonlar",

          "Report-Column-Dialog-Note": "Kolon sırasını sürükle bırak ile değiştir, görünürlüğü açıp kapat.",

          "Report-Default-Columns": "Varsayılan Kolonlar",

          "Report-No-Records": "Kayıt bulunamadı",

          "Report-Rows-Per-Page": "Sayfa başına",

          "Report-Total-Records": "Toplam kayıt",

          "Report-Page": "Sayfa",

          "Report-Export-Language": "Dışa Aktarım Dili",

          "Report-Select-Export-Language": "İndirilecek dosyanın dilini seçiniz.",

          "Report-Download-Excel": "Excel İndir",

          "Report-Download-HTML": "HTML İndir",

          "Report-Output": "Rapor çıktısı",

          "Report-Created-At": "Oluşturulma Tarihi",

          "Report-Visible-Column-Count": "Görünen Kolon",

          "Report-Reporting": "Arkman Raporlama",

          "Report-Sheet-Name": "Rapor",

          "Report-Turkish": "Türkçe",

          "Report-English": "İngilizce",

          "Report-French": "Fransızca",

          "Report-German": "Almanca",

          "Yes": "Evet",

          "No": "Hayır",

          "Report-Debit-Abbr": "B",

          "Report-Credit-Abbr": "A"

        },

        en: {

          "Report-Output": "Report output", "Report-Created-At": "Created at", "Report-Visible-Column-Count": "Visible columns", "Report-Reporting": "Arkman Reporting", "Report-Sheet-Name": "Report", "Yes": "Yes", "No": "No", "Report-Debit-Abbr": "D", "Report-Credit-Abbr": "C"

        },

        fr: {

          "Report-Output": "Sortie du rapport", "Report-Created-At": "Créé le", "Report-Visible-Column-Count": "Colonnes visibles", "Report-Reporting": "Rapports Arkman", "Report-Sheet-Name": "Rapport", "Yes": "Oui", "No": "Non", "Report-Debit-Abbr": "D", "Report-Credit-Abbr": "C"

        },

        de: {

          "Report-Output": "Berichtsausgabe", "Report-Created-At": "Erstellt am", "Report-Visible-Column-Count": "Sichtbare Spalten", "Report-Reporting": "Arkman Berichte", "Report-Sheet-Name": "Bericht", "Yes": "Ja", "No": "Nein", "Report-Debit-Abbr": "S", "Report-Credit-Abbr": "H"

        }

      };

      return common[locale] || common.en;

    },

    getExportMessages(lang) {

      const locale = this.normalizeExportLanguage(lang);

      const maps = {

        tr: trMessages,

        en: enMessages,

        fr: frMessages,

        de: deMessages,

        deC: deCMessages

      };

      return Object.assign({}, this.getCommonExportFallback(locale), maps[locale] || maps.en || {});

    },

    normalizeExportLanguage(lang) {

      let locale = String(lang || "").trim();

      if (locale === "deC") {

        locale = "de";

      }

      if (["tr", "en", "fr", "de"].indexOf(locale) === -1) {

        locale = "en";

      }

      return locale;

    },

    getCurrentMessageLocale() {

      let locale = "";

      if (this.$i18n && this.$i18n.locale) {

        locale = String(this.$i18n.locale);

      }

      if (!locale) {

        locale = localStorage.getItem("lang") || "en";

      }

      if (["tr", "en", "fr", "de", "deC"].indexOf(locale) === -1) {

        locale = "en";

      }

      return locale;

    },

    getExportReverseMessageMap(locale) {
      const normalizedLocale =
        locale === "deC" ? "deC" : this.normalizeExportLanguage(locale);

      if (this.exportReverseMessageCache[normalizedLocale]) {
        return this.exportReverseMessageCache[normalizedLocale];
      }

      const messages = this.getExportMessages(normalizedLocale);
      const reverse = Object.create(null);

      Object.keys(messages).forEach(function (key) {
        const value = messages[key];

        if (
          typeof value === "string" &&
          value !== "" &&
          !Object.prototype.hasOwnProperty.call(reverse, value)
        ) {
          reverse[value] = key;
        }
      });

      this.$set
        ? this.$set(this.exportReverseMessageCache, normalizedLocale, reverse)
        : (this.exportReverseMessageCache[normalizedLocale] = reverse);

      return reverse;
    },

    getCompositeTranslationCandidates(locale) {
      const normalizedLocale =
        locale === "deC" ? "deC" : this.normalizeExportLanguage(locale);

      if (this.exportCompositeCandidateCache[normalizedLocale]) {
        return this.exportCompositeCandidateCache[normalizedLocale];
      }

      const messages = this.getExportMessages(normalizedLocale);

      const candidates = Object.keys(messages)
        .map(function (key) {
          return {
            key: key,
            value: messages[key]
          };
        })
        .filter(function (item) {
          return (
            typeof item.value === "string" &&
            item.value.length >= 3 &&
            item.value.length <= 80
          );
        })
        .sort(function (a, b) {
          return b.value.length - a.value.length;
        });

      this.$set
        ? this.$set(
            this.exportCompositeCandidateCache,
            normalizedLocale,
            candidates
          )
        : (this.exportCompositeCandidateCache[normalizedLocale] = candidates);

      return candidates;
    },

    findExportTranslationKey(text) {
      if (text === null || text === undefined || text === "") {
        return "";
      }

      const raw = String(text);

      /*
       * Önce doğrudan anahtar kontrolü yapılır.
       * Bu kontrol O(1)'dir.
       */
      const currentLocale = this.getCurrentMessageLocale();
      const currentMessages = this.getExportMessages(currentLocale);

      if (Object.prototype.hasOwnProperty.call(currentMessages, raw)) {
        return raw;
      }

      /*
       * Önceden hazırlanmış value -> key haritası ile yine O(1)
       * lookup yapılır. Eski kod her hücrede 3-5 bin anahtarı
       * tek tek dolaşıyordu.
       */
      const currentReverse = this.getExportReverseMessageMap(currentLocale);

      if (Object.prototype.hasOwnProperty.call(currentReverse, raw)) {
        return currentReverse[raw];
      }

      /*
       * UI dili ve localStorage dili farklı kalmış olabileceğinden
       * diğer sözlüklerin reverse map'lerine de bakılır.
       * Bu işlem de her dil için O(1)'dir.
       */
      const locales = ["tr", "en", "fr", "de", "deC"];

      for (let i = 0; i < locales.length; i += 1) {
        const reverse = this.getExportReverseMessageMap(locales[i]);

        if (Object.prototype.hasOwnProperty.call(reverse, raw)) {
          return reverse[raw];
        }
      }

      return "";
    },

    translateExportText(value, lang) {
      if (value === null || value === undefined || value === "") {
        return "";
      }

      const raw = String(value);
      const locale = this.normalizeExportLanguage(lang || this.exportLanguage);
      const cacheKey = locale + "||" + raw;

      if (
        Object.prototype.hasOwnProperty.call(
          this.exportTranslationCache,
          cacheKey
        )
      ) {
        return this.exportTranslationCache[cacheKey];
      }

      const targetMessages = this.getExportMessages(locale);

      const lowered = raw.trim().toLocaleLowerCase("tr-TR");

      if (["evet", "yes", "ja", "oui"].indexOf(lowered) !== -1) {
        const yesValue = targetMessages.Yes || raw;
        this.exportTranslationCache[cacheKey] = yesValue;
        return yesValue;
      }

      if (
        ["hayır", "hayir", "no", "nein", "non"].indexOf(lowered) !== -1
      ) {
        const noValue = targetMessages.No || raw;
        this.exportTranslationCache[cacheKey] = noValue;
        return noValue;
      }

      /*
       * Exact çeviri artık reverse-map üzerinden O(1) çalışır.
       */
      const exactKey = this.findExportTranslationKey(raw);

      if (
        exactKey &&
        Object.prototype.hasOwnProperty.call(targetMessages, exactKey)
      ) {
        const exactValue = targetMessages[exactKey];
        this.exportTranslationCache[cacheKey] = exactValue;
        return exactValue;
      }

      /*
       * Composite çeviri yalnızca gerçekten birleşik başlık olma
       * ihtimali bulunan metinlerde çalışır.
       *
       * Örnek:
       *   "Genel Toplam - USD"
       *   "Satış / İade"
       *
       * Yolcu adı, cari ünvanı, PNR, açıklama vb. normal veri
       * hücrelerinde binlerce dil anahtarını taramaz.
       */
      const shouldTryComposite =
        raw.length <= 140 &&
        (
          raw.indexOf(" - ") !== -1 ||
          raw.indexOf(" / ") !== -1 ||
          raw.indexOf(" (") !== -1 ||
          raw.indexOf(": ") !== -1
        );

      if (!shouldTryComposite) {
        this.exportTranslationCache[cacheKey] = raw;
        return raw;
      }

      const currentLocale = this.getCurrentMessageLocale();
      const currentMessages = this.getExportMessages(currentLocale);
      const candidates = this.getCompositeTranslationCandidates(
        currentLocale
      );

      let result = raw;

      for (let i = 0; i < candidates.length; i += 1) {
        const item = candidates[i];

        if (result.indexOf(item.value) === -1) {
          continue;
        }

        const target = targetMessages[item.key];

        if (
          typeof target === "string" &&
          target !== "" &&
          target !== item.value
        ) {
          result = result.split(item.value).join(target);
        }
      }

      this.exportTranslationCache[cacheKey] = result;
      return result;
    },

    openExportLanguageDialog(type) {

      /*
       * Her yeni dışa aktarımda sonuç cache'i temizlenir.
       * Reverse sözlük cache'leri sabit dil dosyaları olduğu için korunur.
       */
      this.exportTranslationCache = Object.create(null);

      let lang = localStorage.getItem("lang") || (this.$i18n ? this.$i18n.locale : "en") || "en";

      lang = this.normalizeExportLanguage(lang);

      this.exportLanguage = lang;

      this.pendingExportType = type === "html" ? "html" : "excel";

      this.exportLanguageDialog = true;

    },

    closeExportLanguageDialog() {

      this.exportLanguageDialog = false;

    },

    setExportProgress(value) {
      const safeValue = Math.max(0, Math.min(100, Math.round(Number(value) || 0)));
      this.exportProgress = safeValue;
    },

    waitForExportPaint() {
      return new Promise((resolve) => {
        window.requestAnimationFrame(() => {
          window.setTimeout(resolve, 0);
        });
      });
    },

    async updateExportProgress(value) {
      this.setExportProgress(value);
      await this.waitForExportPaint();
    },

    async confirmExportLanguage() {
      const lang = this.normalizeExportLanguage(this.exportLanguage);
      const type = this.pendingExportType;

      this.exportLanguageDialog = false;
      this.exportProcessing = true;
      this.setExportProgress(1);

      try {
        /*
         * Önce loading ekranı gerçekten çizilsin.
         */
        await this.waitForExportPaint();

        /*
         * Dil sözlüğü / reverse map hazırlığı.
         * Bu cache bir kere hazırlanır, her hücrede binlerce key taranmaz.
         */
        await this.updateExportProgress(5);
        this.getExportReverseMessageMap(this.getCurrentMessageLocale());
        this.getExportReverseMessageMap(lang);

        await this.updateExportProgress(10);

        if (type === "html") {
          await this.exportVisibleHtml(lang, true);
        } else {
          await this.exportVisibleCsv(lang, true);
        }

        await this.updateExportProgress(100);

        /*
         * Kullanıcı %100'ü görsün.
         */
        await new Promise((resolve) => {
          window.setTimeout(resolve, 350);
        });
      } catch (error) {
        console.error("Report export error:", error);
      } finally {
        this.exportProcessing = false;
        this.setExportProgress(0);
      }
    },

    getExportLocale(lang) {

      const locale = this.normalizeExportLanguage(lang);

      const locales = {

        tr: "tr-TR",

        en: "en-US",

        fr: "fr-FR",

        de: "de-DE"

      };

      return locales[locale] || "en-US";

    },

    parseFlexibleDate(value) {
      if (value === null || value === undefined || value === "") {
        return null;
      }

      if (value instanceof Date) {
        return isNaN(value.getTime()) ? null : value;
      }

      const raw = String(value).trim();

      if (!raw) {
        return null;
      }

      /*
       * ISO / backend tarihleri:
       * 2026-06-29
       * 2026-06-29T00:00:00
       */
      let match = raw.match(/^(\d{4})-(\d{1,2})-(\d{1,2})/);

      if (match) {
        const year = Number(match[1]);
        const month = Number(match[2]);
        const day = Number(match[3]);

        const date = new Date(year, month - 1, day);

        if (
          date.getFullYear() === year &&
          date.getMonth() === month - 1 &&
          date.getDate() === day
        ) {
          return date;
        }

        return null;
      }

      /*
       * Eski Arkman servislerinde sık kullanılan formatlar:
       * 2.02.2026
       * 29.06.2026
       * 2/02/2026
       * 29/06/2026
       */
      match = raw.match(/^(\d{1,2})[./](\d{1,2})[./](\d{4})(?:\s.*)?$/);

      if (match) {
        const day = Number(match[1]);
        const month = Number(match[2]);
        const year = Number(match[3]);

        const date = new Date(year, month - 1, day);

        if (
          date.getFullYear() === year &&
          date.getMonth() === month - 1 &&
          date.getDate() === day
        ) {
          return date;
        }

        return null;
      }

      /*
       * Son fallback:
       * Browser'ın güvenli biçimde parse edebildiği standart tarihleri kullan.
       * "2.02.2026" gibi locale-dependent değerler buraya bırakılmaz.
       */
      const parsed = new Date(raw);

      return isNaN(parsed.getTime()) ? null : parsed;
    },

    formatDisplayDate(value) {
      const date = this.parseFlexibleDate(value);

      if (!date) {
        /*
         * Tarih parse edilemiyorsa "Invalid Date" göstermek yerine
         * backend'den gelen ham değeri koru.
         */
        return value === null || value === undefined ? "" : String(value);
      }

      /*
       * Ekrandaki eski Arkman görünümü korunur: dd.MM.yyyy
       */
      const day = String(date.getDate()).padStart(2, "0");
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const year = date.getFullYear();

      return day + "." + month + "." + year;
    },

    formatExportDate(value, lang) {

      if (value === null || value === undefined || value === "") {

        return "";

      }

      const date = this.parseFlexibleDate(value);

      if (!date) {

        /*
         * Parse edilemeyen değer varsa veri kaybolmasın.
         */
        return String(value);

      }

      return new Intl.DateTimeFormat(this.getExportLocale(lang), {

        year: "numeric",

        month: "2-digit",

        day: "2-digit"

      }).format(date);

    },

    formatExportMoney(value, lang) {

      const number = this.getRawNumberValue(value);

      return new Intl.NumberFormat(this.getExportLocale(lang), {

        minimumFractionDigits: 2,

        maximumFractionDigits: 2

      }).format(number);

    },

    formatExportBalance(value, lang) {

      const number = this.getRawNumberValue(value);

      const messages = this.getExportMessages(lang);

      if (number > 0) {

        return this.formatExportMoney(number, lang) + " " + (messages["Report-Debit-Abbr"] || "B");

      }

      if (number < 0) {

        return this.formatExportMoney(number * -1, lang) + " " + (messages["Report-Credit-Abbr"] || "A");

      }

      return this.formatExportMoney(0, lang);

    },

    setupHeaders(headers) {

      const mapped = (headers || []).map(function (item) {

        const incomingWidth =

          item && item.width !== undefined && item.width !== null

            ? item.width

            : "140px";

        return Object.assign(

          {

            visible: true,

            sortable: true,

            type: "text",

            align: "left",

            minWidth: "1px",

            width: incomingWidth

          },

          item,

          {

            minWidth: "1px"

          }

        );

      });

      this.defaultHeadersSnapshot = JSON.parse(JSON.stringify(mapped));

      this.internalHeaders = mapped;

      this.loadColumnSettings();

      this.$nextTick(() => {

        this.updateTopScrollbar();

      });

    },

    syncTopScroll(e) {

      if (this.$refs.tableWrapper) {

        this.$refs.tableWrapper.scrollLeft = e.target.scrollLeft;

      }

    },

    syncBottomScroll(e) {

      if (this.$refs.reportScrollTop) {

        this.$refs.reportScrollTop.scrollLeft = e.target.scrollLeft;

      }

    },

    updateTopScrollbar() {

      this.$nextTick(() => {

        const table = this.$refs.reportRealTable;

        if (!table || !this.$refs.reportScrollInner) {

          return;

        }

        this.$refs.reportScrollInner.style.width = table.scrollWidth + "px";

      });

    },

    onColumnVisibilityChange() {

      this.saveColumnSettings();

      this.$nextTick(() => {

        this.updateTopScrollbar();

      });

    },

    isEmptyValue(val) {

      return val === null || val === undefined || val === "";

    },

    formatCellValue(item, column) {

      if (!item || !column) {

        return "";

      }

      const value = item[column.value];

      if (column.type === "date") {

        return this.isEmptyValue(value) ? "" : this.formatDisplayDate(value);

      }

      if (column.type === "money") {

        return this.isEmptyValue(value) ? "" : helpers.moneyformat(value);

      }

      if (column.type === "balance") {

        return this.isEmptyValue(value) ? "" : this.formatBalance(value);

      }

      return this.isEmptyValue(value) ? "" : value;

    },

    formatBalance(val) {

      if (val > 0) {

        return helpers.moneyformat(val) + " B";

      } else if (val == 0) {

        return helpers.moneyformat(val);

      } else {

        return helpers.moneyformat(val * -1) + " A";

      }

    },

    getExportValue(item, column) {

      return this.formatCellValue(item, column);

    },

    getRawNumberValue(value) {

      if (value === null || value === undefined || value === "") {

        return 0;

      }

      if (typeof value === "number") {

        return isNaN(value) ? 0 : value;

      }

      const normalized = String(value)

        .replace(/\s/g, "")

        .replace(/\./g, "")

        .replace(/,/g, ".");

      const parsed = parseFloat(normalized);

      return isNaN(parsed) ? 0 : parsed;

    },

    calculateSummaryTotals() {

      const config = this.excelSummaryConfig;

      if (

        !config ||

        !Array.isArray(config.fields) ||

        !config.fields.length

      ) {

        return {};

      }

      const totals = {};

      config.fields.forEach(function (field) {

        if (field && field.key) {

          totals[field.key] = 0;

        }

      });

      this.filteredItems.forEach((item) => {

        config.fields.forEach((field) => {

          if (!field || !field.key) {

            return;

          }

          totals[field.key] += this.getRawNumberValue(item[field.key]);

        });

      });

      return totals;

    },

    buildSummaryRow(exportColumns, lang) {

      const config = this.excelSummaryConfig;

      if (

        !config ||

        !Array.isArray(config.fields) ||

        !config.fields.length ||

        !Array.isArray(exportColumns) ||

        !exportColumns.length

      ) {

        return null;

      }

      const totals = this.calculateSummaryTotals();

      const firstVisibleColumnValue = exportColumns[0].value;

      const label = this.translateExportText(config.label || "General-Totals", lang);

      return exportColumns.map((column) => {

        if (column.value === firstVisibleColumnValue) {

          return label;

        }

        const fieldConfig = config.fields.find(function (field) {

          return field && field.key === column.value;

        });

        if (!fieldConfig) {

          return "";

        }

        const totalValue = totals[column.value] || 0;

        if (fieldConfig.type === "money" || column.type === "money") {

          return helpers.moneyformat(totalValue);

        }

        return totalValue;

      });

    },

    formatExtraExportValue(item, rawForExcel, lang) {

      if (!item) {

        return "";

      }

      const value = item.value;

      if (value === null || value === undefined || value === "") {

        return "";

      }

      if (item.type === "money") {

        if (rawForExcel === true) {

          return this.getRawNumberValue(value);

        }

        return this.formatExportMoney(value, lang);

      }

      if (item.type === "date") {

        return this.formatExportDate(value, lang);

      }

      if (item.type === "balance") {

        return this.formatExportBalance(value, lang);

      }

      return this.translateExportText(value, lang);

    },

    buildExcelIntroRows(lang) {

      const rows = [];

      const title = this.getExportTitle(lang);

      if (title) {

        rows.push([title]);

      }

      if (Array.isArray(this.exportMetaItems)) {

        this.exportMetaItems.forEach((item) => {

          if (!item || !item.label) {

            return;

          }

          rows.push([

            this.translateExportText(item.label, lang),

            this.formatExtraExportValue(item, true, lang)

          ]);

        });

      }

      if (Array.isArray(this.exportSummaryCards) && this.exportSummaryCards.length) {

        rows.push([]);

        this.exportSummaryCards.forEach((card) => {

          if (!card) {

            return;

          }

          rows.push([this.translateExportText(card.title || "", lang)]);

          if (Array.isArray(card.items)) {

            card.items.forEach((item) => {

              if (!item || !item.label) {

                return;

              }

              rows.push([

                this.translateExportText(item.label, lang),

                this.formatExtraExportValue(item, true, lang)

              ]);

            });

          }

        });

      }

      if (rows.length) {

        rows.push([]);

      }

      return rows;

    },

    buildHtmlMetaItems(lang) {

      if (!Array.isArray(this.exportMetaItems) || !this.exportMetaItems.length) {

        return "";

      }

      return this.exportMetaItems

        .filter(function (item) {

          return item && item.label;

        })

        .map((item) => {

          return '<span>' +

            this.htmlEscape(this.translateExportText(item.label, lang)) +

            ': <strong>' +

            this.htmlEscape(this.formatExtraExportValue(item, false, lang)) +

            '</strong></span>';

        })

        .join("");

    },

    buildHtmlSummaryCards(lang) {

      if (!Array.isArray(this.exportSummaryCards) || !this.exportSummaryCards.length) {

        return "";

      }

      return '<div class="export-summary-grid">' +

        this.exportSummaryCards

          .filter(function (card) {

            return !!card;

          })

          .map((card) => {

            const rows = Array.isArray(card.items)

              ? card.items

                  .filter(function (item) {

                    return item && item.label;

                  })

                  .map((item) => {

                    return '<div class="export-summary-row">' +

                      '<span>' + this.htmlEscape(this.translateExportText(item.label, lang)) + '</span>' +

                      '<strong>' + this.htmlEscape(this.formatExtraExportValue(item, false, lang)) + '</strong>' +

                      '</div>';

                  })

                  .join("")

              : "";

            return '<div class="export-summary-card">' +

              '<div class="export-summary-title">' + this.htmlEscape(this.translateExportText(card.title || "", lang)) + '</div>' +

              rows +

              '</div>';

          })

          .join("") +

        '</div>';

    },

    csvEscape(value) {

      const stringValue = String(value == null ? "" : value).replace(/"/g, '""');

      return '"' + stringValue + '"';

    },

    getExcelBorderStyle() {
      return {
        top: { style: "thin", color: { rgb: "D9E2F3" } },
        bottom: { style: "thin", color: { rgb: "D9E2F3" } },
        left: { style: "thin", color: { rgb: "D9E2F3" } },
        right: { style: "thin", color: { rgb: "D9E2F3" } }
      };
    },

    getExcelCellStyle(kind) {
      const border = this.getExcelBorderStyle();

      const styles = {
        title: {
          font: {
            bold: true,
            color: { rgb: "FF0000" },
            sz: 16
          },
          alignment: {
            vertical: "center",
            horizontal: "left"
          }
        },

        metaLabel: {
          font: {
            bold: true,
            color: { rgb: "37474F" }
          },
          fill: {
            patternType: "solid",
            fgColor: { rgb: "EAF4FB" }
          },
          alignment: {
            vertical: "center",
            horizontal: "left",
            wrapText: true
          },
          border: border
        },

        metaValue: {
          font: {
            color: { rgb: "263238" }
          },
          alignment: {
            vertical: "center",
            horizontal: "left",
            wrapText: true
          },
          border: border
        },

        section: {
          font: {
            bold: true,
            color: { rgb: "FFFFFF" }
          },
          fill: {
            patternType: "solid",
            fgColor: { rgb: "2196F3" }
          },
          alignment: {
            vertical: "center",
            horizontal: "left"
          },
          border: border
        },

        tableHeader: {
          font: {
            bold: true,
            color: { rgb: "0F2D3D" }
          },
          fill: {
            patternType: "solid",
            fgColor: { rgb: "16C1E8" }
          },
          alignment: {
            vertical: "center",
            horizontal: "center",
            wrapText: true
          },
          border: {
            top: { style: "thin", color: { rgb: "129DBA" } },
            bottom: { style: "thin", color: { rgb: "129DBA" } },
            left: { style: "thin", color: { rgb: "129DBA" } },
            right: { style: "thin", color: { rgb: "129DBA" } }
          }
        },

        data: {
          alignment: {
            vertical: "top",
            wrapText: true
          },
          border: border
        },

        total: {
          font: {
            bold: true,
            color: { rgb: "263238" }
          },
          fill: {
            patternType: "solid",
            fgColor: { rgb: "D0D0D0" }
          },
          alignment: {
            vertical: "center",
            wrapText: true
          },
          border: {
            top: { style: "medium", color: { rgb: "9E9E9E" } },
            bottom: { style: "thin", color: { rgb: "BDBDBD" } },
            left: { style: "thin", color: { rgb: "BDBDBD" } },
            right: { style: "thin", color: { rgb: "BDBDBD" } }
          }
        }
      };

      return styles[kind] || styles.data;
    },

    mergeExcelStyles(baseStyle, extraStyle) {
      const result = Object.assign({}, baseStyle || {});

      Object.keys(extraStyle || {}).forEach(function (key) {
        const value = extraStyle[key];

        if (
          value &&
          typeof value === "object" &&
          !Array.isArray(value)
        ) {
          result[key] = Object.assign({}, result[key] || {}, value);
        } else {
          result[key] = value;
        }
      });

      return result;
    },

    applyExcelStyles(worksheet, config) {
      if (!worksheet || !config) {
        return;
      }

      const columnCount = Math.max(Number(config.columnCount) || 1, 1);
      const titleRowIndex = config.titleRowIndex;
      const headerRowIndex = config.headerRowIndex;
      const dataStartRowIndex = config.dataStartRowIndex;
      const dataEndRowIndex = config.dataEndRowIndex;
      const summaryRowIndex = config.summaryRowIndex;
      const introRows = Array.isArray(config.introRows) ? config.introRows : [];

      const applyRowStyle = (rowIndex, styleName) => {
        if (rowIndex === null || rowIndex === undefined || rowIndex < 0) {
          return;
        }

        for (let colIndex = 0; colIndex < columnCount; colIndex += 1) {
          const address = XLSX.utils.encode_cell({
            r: rowIndex,
            c: colIndex
          });

          if (!worksheet[address]) {
            worksheet[address] = {
              t: "s",
              v: ""
            };
          }

          worksheet[address].s = this.mergeExcelStyles(
            worksheet[address].s,
            this.getExcelCellStyle(styleName)
          );
        }
      };

      /*
       * Ana rapor başlığı:
       * Eski Excel mantığına yakın olacak şekilde kırmızı, büyük ve kalın.
       */
      if (
        titleRowIndex !== null &&
        titleRowIndex !== undefined &&
        titleRowIndex >= 0
      ) {
        applyRowStyle(titleRowIndex, "title");

        if (columnCount > 1) {
          worksheet["!merges"] = worksheet["!merges"] || [];
          worksheet["!merges"].push({
            s: { r: titleRowIndex, c: 0 },
            e: { r: titleRowIndex, c: columnCount - 1 }
          });
        }

        worksheet["!rows"] = worksheet["!rows"] || [];
        worksheet["!rows"][titleRowIndex] = {
          hpt: 24
        };
      }

      /*
       * Üst bilgi / filtre alanları:
       * A sütunundaki başlık hafif mavi, değer hücresi sade.
       * Tek hücrelik bölüm başlıkları mavi blok olarak görünür.
       */
      for (let rowIndex = 0; rowIndex < introRows.length; rowIndex += 1) {
        if (rowIndex === titleRowIndex) {
          continue;
        }

        const row = introRows[rowIndex];

        if (!Array.isArray(row) || !row.length) {
          continue;
        }

        const nonEmptyCells = row.filter(function (value) {
          return value !== null &&
            value !== undefined &&
            String(value).trim() !== "";
        });

        if (!nonEmptyCells.length) {
          continue;
        }

        if (nonEmptyCells.length === 1) {
          applyRowStyle(rowIndex, "section");

          if (columnCount > 1) {
            worksheet["!merges"] = worksheet["!merges"] || [];
            worksheet["!merges"].push({
              s: { r: rowIndex, c: 0 },
              e: { r: rowIndex, c: columnCount - 1 }
            });
          }
        } else {
          const labelAddress = XLSX.utils.encode_cell({
            r: rowIndex,
            c: 0
          });

          const valueAddress = XLSX.utils.encode_cell({
            r: rowIndex,
            c: 1
          });

          if (worksheet[labelAddress]) {
            worksheet[labelAddress].s = this.mergeExcelStyles(
              worksheet[labelAddress].s,
              this.getExcelCellStyle("metaLabel")
            );
          }

          if (worksheet[valueAddress]) {
            worksheet[valueAddress].s = this.mergeExcelStyles(
              worksheet[valueAddress].s,
              this.getExcelCellStyle("metaValue")
            );
          }
        }
      }

      /*
       * Tablo kolon başlıkları.
       */
      applyRowStyle(headerRowIndex, "tableHeader");

      worksheet["!rows"] = worksheet["!rows"] || [];
      worksheet["!rows"][headerRowIndex] = {
        hpt: 23
      };

      /*
       * Veri satırlarına ince border ve wrap uygula.
       */
      if (
        dataStartRowIndex !== null &&
        dataStartRowIndex !== undefined &&
        dataEndRowIndex !== null &&
        dataEndRowIndex !== undefined &&
        dataEndRowIndex >= dataStartRowIndex
      ) {
        for (
          let rowIndex = dataStartRowIndex;
          rowIndex <= dataEndRowIndex;
          rowIndex += 1
        ) {
          applyRowStyle(rowIndex, "data");
        }
      }

      /*
       * Genel toplam / summary satırı.
       */
      if (
        summaryRowIndex !== null &&
        summaryRowIndex !== undefined &&
        summaryRowIndex >= 0
      ) {
        applyRowStyle(summaryRowIndex, "total");
      }

      /*
       * Görünüm ayarları.
       */
      worksheet["!autofilter"] = {
        ref:
          XLSX.utils.encode_cell({ r: headerRowIndex, c: 0 }) +
          ":" +
          XLSX.utils.encode_cell({
            r: headerRowIndex,
            c: columnCount - 1
          })
      };
    },

    async exportVisibleCsv(lang, showProgress) {

      const exportColumns = this.visibleColumns.filter(column => column.exportable !== false);

      const exportRows = this.filteredItems;

      if (!exportColumns.length) {
        return;
      }

      const excelData = this.buildExcelIntroRows(lang);

      /*
       * Stil uygulanacak satırları, veri eklenmeden önce kaydediyoruz.
       */
      const introRowsForStyle = excelData.map(function (row) {
        return Array.isArray(row) ? row.slice() : row;
      });

      const titleRowIndex =
        excelData.length &&
        Array.isArray(excelData[0]) &&
        excelData[0].length === 1 &&
        excelData[0][0]
          ? 0
          : null;

      if (showProgress) {
        await this.updateExportProgress(15);
      }

      /*
       * Kolon başlıkları
       */
      const headerRowIndex = excelData.length;

      excelData.push(
        exportColumns.map((column) => {
          return this.translateExportText(column.text, lang);
        })
      );

      const dataStartRowIndex = excelData.length;

      const totalRows = exportRows.length;
      const chunkSize = 100;

      /*
       * Rapor satırlarını küçük parçalar halinde hazırlıyoruz.
       * Her chunk sonrası browser'a repaint şansı verildiği için
       * yüzde 1 -> 100 ilerlerken sayfa "yanıt vermiyor" durumuna düşmez.
       */
      for (let rowIndex = 0; rowIndex < totalRows; rowIndex += chunkSize) {

        const chunkEnd = Math.min(rowIndex + chunkSize, totalRows);

        for (let i = rowIndex; i < chunkEnd; i += 1) {

          const item = exportRows[i];

          const row = exportColumns.map((column) => {

            if (column.type === "money") {

              const rawValue = item[column.value];

              if (rawValue === null || rawValue === undefined || rawValue === "") {
                return "";
              }

              return this.getRawNumberValue(rawValue);
            }

            if (column.type === "balance") {
              return this.formatExportBalance(item[column.value], lang);
            }

            if (column.type === "date") {
              return this.formatExportDate(item[column.value], lang);
            }

            const value = this.getExportValue(item, column);

            return column.translateValue === false
              ? value
              : this.translateExportText(value, lang);
          });

          excelData.push(row);
        }

        if (showProgress && totalRows > 0) {
          const rowProgress = chunkEnd / totalRows;

          /*
           * 15 - 78 arası satır hazırlama ilerlemesi.
           */
          const progressValue = 15 + Math.round(rowProgress * 63);

          await this.updateExportProgress(progressValue);
        }
      }

      const dataEndRowIndex =
        excelData.length > dataStartRowIndex
          ? excelData.length - 1
          : dataStartRowIndex - 1;

      const summaryRowValues = this.buildSummaryRow(exportColumns, lang);

      let summaryRowIndex = null;

      if (summaryRowValues && summaryRowValues.length) {
        summaryRowIndex = excelData.length;
        excelData.push(summaryRowValues);
      }

      if (showProgress) {
        await this.updateExportProgress(82);
      }

      /*
       * Worksheet üretimi.
       */
      const worksheet = XLSX.utils.aoa_to_sheet(excelData);

      worksheet["!cols"] = exportColumns.map((column) => {

        const pixelWidth = this.parseWidth(column.width || column.minWidth, 140);

        return {
          wch: Math.max(10, Math.round(pixelWidth / 7))
        };
      });

      /*
       * XLSX-JS-STYLE ile tüm raporlarda merkezi Excel tasarımı.
       * Tek tek rapor Vue dosyalarına stil kodu eklenmez.
       */
      this.applyExcelStyles(worksheet, {
        columnCount: exportColumns.length,
        titleRowIndex: titleRowIndex,
        headerRowIndex: headerRowIndex,
        dataStartRowIndex: dataStartRowIndex,
        dataEndRowIndex: dataEndRowIndex,
        summaryRowIndex: summaryRowIndex,
        introRows: introRowsForStyle
      });

      if (showProgress) {
        await this.updateExportProgress(88);
      }

      const workbook = XLSX.utils.book_new();

      XLSX.utils.book_append_sheet(
        workbook,
        worksheet,
        this.getSafeSheetName(
          this.translateExportText("Report-Sheet-Name", lang)
        )
      );

      const fileName = this.getExportFileName(lang);

      /*
       * XLSX.writeFile senkron bir SheetJS çağrısıdır.
       * Bu bölüm genellikle kısa sürer. Öncesinde %92 gösterip
       * browser'ın bunu çizmesine izin veriyoruz.
       */
      if (showProgress) {
        await this.updateExportProgress(92);
      }

      XLSX.writeFile(workbook, fileName + ".xlsx");

      if (showProgress) {
        await this.updateExportProgress(99);
      }
    },

    getSafeSheetName(value) {

      let name = String(value || "Report").replace(/[\/?*\[\]:]/g, " ").trim();

      if (!name) { name = "Report"; }

      return name.slice(0, 31);

    },

    getExportFileName(lang) {

      let fileName = this.getExportTitle(lang) || this.storageKey || "rapor";

      fileName = String(fileName)

        .replace(/[\/:*?"<>|]/g, "_")

        .replace(/\s+/g, "_");

      return fileName || "rapor";

    },

    getExportTitle(lang) {

      if (this.exportTitle) {

        return this.translateExportText(String(this.exportTitle), lang);

      }

      const raw = String(this.storageKey || "Rapor")

        .replace(/[_-]+/g, " ")

        .replace(/\s+/g, " ")

        .trim();

      if (!raw) {

        return this.translateExportText("Report-Sheet-Name", lang) || "Rapor";

      }

      return raw

        .split(" ")

        .map(function (word) {

          if (!word) {

            return "";

          }

          return word.charAt(0).toLocaleUpperCase("tr-TR") + word.slice(1);

        })

        .join(" ");

    },

    htmlEscape(value) {

      return String(value == null ? "" : value)

        .replace(/&/g, "&amp;")

        .replace(/</g, "&lt;")

        .replace(/>/g, "&gt;")

        .replace(/"/g, "&quot;")

        .replace(/'/g, "&#039;");

    },

    async exportVisibleHtml(lang, showProgress) {

      const exportColumns = this.visibleColumns.filter(column => column.exportable !== false);

      const exportRows = this.filteredItems;

      if (!exportColumns.length) {

        return;

      }

      /*

       * HTML çıktısı da Excel ile aynı veri kaynağını kullanır.

       * Böylece kullanıcının ekranda uyguladığı arama, sıralama ve

       * kolon görünürlüğü HTML raporunda da korunur.

       */

      const title = this.getExportTitle(lang);

      const fileName = this.getExportFileName(lang);

      const createdAt = new Date().toLocaleString(this.getExportLocale(lang));

      const customMetaHtml = this.buildHtmlMetaItems(lang);

      const summaryCardsHtml = this.buildHtmlSummaryCards(lang);

      const headerHtml = exportColumns

        .map((column) => {

          return "<th>" + this.htmlEscape(this.translateExportText(column.text, lang)) + "</th>";

        })

        .join("");

      const bodyParts = [];
      const totalRows = exportRows.length;
      const chunkSize = 100;

      if (showProgress) {
        await this.updateExportProgress(18);
      }

      for (let rowIndex = 0; rowIndex < totalRows; rowIndex += chunkSize) {

        const chunkEnd = Math.min(rowIndex + chunkSize, totalRows);

        for (let i = rowIndex; i < chunkEnd; i += 1) {

          const item = exportRows[i];

          const cells = exportColumns
            .map((column) => {

              let value = this.getExportValue(item, column);

              if (column.type === "money") {
                value = this.formatExportMoney(item[column.value], lang);
              }

              if (column.type === "date") {
                value = this.formatExportDate(item[column.value], lang);
              }

              if (column.type === "balance") {
                value = this.formatExportBalance(item[column.value], lang);
              }

              if (column.translateValue !== false) {
                value = this.translateExportText(value, lang);
              }

              return "<td>" + this.htmlEscape(value) + "</td>";
            })
            .join("");

          bodyParts.push("<tr>" + cells + "</tr>");
        }

        if (showProgress && totalRows > 0) {

          /*
           * 18 - 82 arası HTML satır hazırlama ilerlemesi.
           */
          const rowProgress = chunkEnd / totalRows;
          const progressValue = 18 + Math.round(rowProgress * 64);

          await this.updateExportProgress(progressValue);
        }
      }

      const bodyHtml = bodyParts.join("");

      const summaryRowValues = this.buildSummaryRow(exportColumns, lang);

      let summaryHtml = "";

      if (summaryRowValues && summaryRowValues.length) {

        summaryHtml =

          '<tr class="summary-row">' +

          summaryRowValues

            .map((value) => {

              return "<td>" + this.htmlEscape(value) + "</td>";

            })

            .join("") +

          "</tr>";

      }

      if (showProgress) {
        await this.updateExportProgress(88);
      }

      const htmlContent = `<!DOCTYPE html>

<html lang="${this.normalizeExportLanguage(lang)}">

<head>

  <meta charset="UTF-8">

  <meta name="viewport" content="width=device-width, initial-scale=1.0">

  <title>${this.htmlEscape(title)}</title>

  <style>

    * { box-sizing: border-box; }

    body { margin: 0; padding: 32px; background: #f4f7fb; color: #263238; font-family: Arial, Helvetica, sans-serif; }

    .report-shell { max-width: 1800px; margin: 0 auto; background: #fff; border: 1px solid #e4eaf1; border-radius: 14px; box-shadow: 0 10px 30px rgba(38, 50, 56, 0.08); overflow: hidden; }

    .report-header { padding: 24px 28px; background: #fff; border-bottom: 3px solid #16c1e8; }

    .report-header h1 { margin: 0; color: #e53935; font-size: 24px; font-weight: 800; }

    .report-header p { margin: 7px 0 0; color: #78909c; font-size: 12px; }

    .report-meta-export { display: flex; flex-wrap: wrap; gap: 10px; padding: 16px 28px; border-bottom: 1px solid #e9eef4; background: #fbfcfe; }

    .report-meta-export span { padding: 7px 11px; border: 1px solid #dde6ef; border-radius: 999px; background: #fff; color: #607d8b; font-size: 11px; }

    .export-summary-grid { display: grid; grid-template-columns: repeat(auto-fit, minmax(230px, 1fr)); gap: 12px; padding: 18px 28px 4px; }

    .export-summary-card { border: 1px solid #dce6ef; border-radius: 10px; background: #fff; overflow: hidden; }

    .export-summary-title { padding: 10px 12px; background: #eef6fd; color: #1565c0; font-weight: 700; font-size: 12px; border-bottom: 1px solid #dce6ef; }

    .export-summary-row { display: flex; justify-content: space-between; gap: 16px; padding: 8px 12px; border-bottom: 1px solid #eef2f6; font-size: 11px; }

    .export-summary-row:last-child { border-bottom: 0; }

    .export-summary-row span { color: #607d8b; }

    .export-summary-row strong { color: #263238; text-align: right; }

    .table-container { width: 100%; overflow-x: auto; padding: 20px 28px 28px; }

    table { width: 100%; min-width: 900px; border-collapse: separate; border-spacing: 0; border: 1px solid #e3e9ef; border-radius: 10px; overflow: hidden; font-size: 12px; }

    thead th { padding: 11px 10px; text-align: left; background: #16c1e8; color: #0f2d3d; border-right: 1px solid #129dba; border-bottom: 1px solid #129dba; font-weight: 800; white-space: nowrap; }

    tbody td { padding: 9px 10px; border-right: 1px solid #eef2f6; border-bottom: 1px solid #eef2f6; vertical-align: top; }

    tbody tr:nth-child(even) td { background: #fbfdff; }

    th:last-child, td:last-child { border-right: 0; }

    tbody tr:last-child td { border-bottom: 0; }

    .summary-row td { background: #d0d0d0 !important; color: #263238; font-weight: 800; border-top: 2px solid #9e9e9e; }

    .report-footer { padding: 12px 28px 18px; color: #90a4ae; font-size: 10px; text-align: right; }

    @media print {

      body { padding: 0; background: #fff; }

      .report-shell { max-width: none; border: 0; border-radius: 0; box-shadow: none; }

      .table-container { overflow: visible; }

      table { min-width: 0; font-size: 9px; }

      thead { display: table-header-group; }

      tr { page-break-inside: avoid; }

    }

.export-language-note { margin-bottom: 14px; color: #607d8b; font-size: 13px; }

</style>

</head>

<body>

  <div class="report-shell">

    <div class="report-header">

      <h1>${this.htmlEscape(title)}</h1>

      <p>${this.htmlEscape(this.translateExportText("Report-Output", lang))}</p>

    </div>

    <div class="report-meta-export">

      <span>${this.htmlEscape(this.translateExportText("Report-Total-Records", lang))}: <strong>${exportRows.length}</strong></span>

      <span>${this.htmlEscape(this.translateExportText("Report-Visible-Column-Count", lang))}: <strong>${exportColumns.length}</strong></span>

      <span>${this.htmlEscape(this.translateExportText("Report-Created-At", lang))}: <strong>${this.htmlEscape(createdAt)}</strong></span>

      ${customMetaHtml}

    </div>

    ${summaryCardsHtml}

    <div class="table-container">

      <table>

        <thead><tr>${headerHtml}</tr></thead>

        <tbody>${bodyHtml}${summaryHtml}</tbody>

      </table>

    </div>

    <div class="report-footer">${this.htmlEscape(this.translateExportText("Report-Reporting", lang))}</div>

  </div>

</body>

</html>`;

      if (showProgress) {
        await this.updateExportProgress(94);
      }

      const blob = new Blob(["\uFEFF" + htmlContent], {

        type: "text/html;charset=utf-8;"

      });

      const link = document.createElement("a");

      const url = window.URL.createObjectURL(blob);

      link.href = url;

      link.download = fileName + ".html";

      document.body.appendChild(link);

      link.click();

      if (showProgress) {
        await this.updateExportProgress(99);
      }

      document.body.removeChild(link);

      window.URL.revokeObjectURL(url);

    },

    onHeaderClick(event, header) {

      if (this.isResizing) {

        return;

      }

      if (

        event &&

        event.target &&

        event.target.closest &&

        event.target.closest(".column-resizer")

      ) {

        return;

      }

      if (header.sortable) {

        this.toggleSort(header.value);

      }

    },

    toggleSort(columnValue) {

      if (this.sortBy === columnValue) {

        this.sortDesc = !this.sortDesc;

      } else {

        this.sortBy = columnValue;

        this.sortDesc = false;

      }

      this.$nextTick(() => {

        this.updateTopScrollbar();

      });

    },

    sortFunction(a, b) {

      const column = this.internalHeaders.find((x) => x.value === this.sortBy);

      if (!column) {

        return 0;

      }

      const aVal = a ? a[column.value] : null;

      const bVal = b ? b[column.value] : null;

      let result = 0;

      if (column.type === "money" || column.type === "balance") {

        const aNum = parseFloat(aVal) || 0;

        const bNum = parseFloat(bVal) || 0;

        result = aNum === bNum ? 0 : aNum > bNum ? 1 : -1;

      } else if (column.type === "date") {

        const aParsed = this.parseFlexibleDate(aVal);

        const bParsed = this.parseFlexibleDate(bVal);

        const aDate = aParsed ? aParsed.getTime() : 0;

        const bDate = bParsed ? bParsed.getTime() : 0;

        result = aDate === bDate ? 0 : aDate > bDate ? 1 : -1;

      } else {

        const aText = String(aVal == null ? "" : aVal).toLocaleLowerCase("tr-TR");

        const bText = String(bVal == null ? "" : bVal).toLocaleLowerCase("tr-TR");

        result = aText.localeCompare(bText, "tr");

      }

      return this.sortDesc ? result * -1 : result;

    },

    goToFirstPage() {

      this.page = 1;

    },

    goToLastPage() {

      this.page = this.totalPages;

    },

    onColumnDragStart(index) {

      this.draggedColumnIndex = index;

    },

    onColumnDrop(index) {

      if (this.draggedColumnIndex === null || this.draggedColumnIndex === index) {

        this.draggedColumnIndex = null;

        return;

      }

      const sourceColumns = this.internalHeaders.slice();

      const movedItem = sourceColumns.splice(this.draggedColumnIndex, 1)[0];

      sourceColumns.splice(index, 0, movedItem);

      this.internalHeaders = sourceColumns;

      this.draggedColumnIndex = null;

      this.saveColumnSettings();

      this.updateTopScrollbar();

    },

    onHeaderDragStart(event, index) {

      if (this.isResizing) {

        event.preventDefault();

        return;

      }

      if (

        event &&

        event.target &&

        event.target.closest &&

        event.target.closest(".column-resizer")

      ) {

        event.preventDefault();

        return;

      }

      this.draggedHeaderIndex = index;

    },

    onHeaderDrop(targetVisibleIndex) {

      if (this.isResizing) {

        this.draggedHeaderIndex = null;

        return;

      }

      if (

        this.draggedHeaderIndex === null ||

        this.draggedHeaderIndex === targetVisibleIndex

      ) {

        this.draggedHeaderIndex = null;

        return;

      }

      const visible = this.visibleColumns.slice();

      const draggedVisible = visible[this.draggedHeaderIndex];

      const targetVisible = visible[targetVisibleIndex];

      if (!draggedVisible || !targetVisible) {

        this.draggedHeaderIndex = null;

        return;

      }

      const sourceIndex = this.internalHeaders.findIndex((x) => x.value === draggedVisible.value);

      const targetIndex = this.internalHeaders.findIndex((x) => x.value === targetVisible.value);

      if (sourceIndex === -1 || targetIndex === -1) {

        this.draggedHeaderIndex = null;

        return;

      }

      const updated = this.internalHeaders.slice();

      const moved = updated.splice(sourceIndex, 1)[0];

      updated.splice(targetIndex, 0, moved);

      this.internalHeaders = updated;

      this.draggedHeaderIndex = null;

      this.saveColumnSettings();

      this.updateTopScrollbar();

    },

    parseWidth(value, fallback) {

      if (typeof value === "number" && !isNaN(value)) {

        return value;

      }

      const parsed = parseInt(value, 10);

      return isNaN(parsed) ? fallback : parsed;

    },

    getColStyle(column) {

      const width = this.parseWidth(column.width || column.minWidth, 140);

      const minWidth = 1;

      return {

        width: width + "px",

        minWidth: minWidth + "px",

        maxWidth: width + "px"

      };

    },

    startResize(event, column) {

      if (!column || !column.value) {

        return;

      }

      this.isResizing = true;

      this.draggedHeaderIndex = null;

      this.resizeState = {

        active: true,

        columnValue: column.value,

        startX: event.clientX,

        startWidth: this.parseWidth(column.width || column.minWidth, 140)

      };

      document.body.classList.add("report-table-resizing");

    },

    onResizeMouseMove(event) {

      if (!this.resizeState.active) {

        return;

      }

      const columnIndex = this.internalHeaders.findIndex(function (x) {

        return x.value === this.resizeState.columnValue;

      }, this);

      if (columnIndex === -1) {

        return;

      }

      const currentColumn = this.internalHeaders[columnIndex];

      const minWidth = 1;

      const delta = event.clientX - this.resizeState.startX;

      const nextWidth = Math.max(minWidth, this.resizeState.startWidth + delta);

      const updated = this.internalHeaders.slice();

      updated[columnIndex] = Object.assign({}, updated[columnIndex], {

        width: nextWidth + "px",

        minWidth: "1px"

      });

      this.internalHeaders = updated;

      this.$nextTick(() => {

        this.updateTopScrollbar();

      });

    },

    stopResize() {

      if (!this.resizeState.active) {

        return;

      }

      this.resizeState = {

        active: false,

        columnValue: "",

        startX: 0,

        startWidth: 0

      };

      this.isResizing = false;

      document.body.classList.remove("report-table-resizing");

      this.saveColumnSettings();

      this.$nextTick(() => {

        this.updateTopScrollbar();

      });

    },

    saveColumnSettings() {

      try {

        const payload = this.internalHeaders.map(function (column) {

          return {

            text: column.text,

            value: column.value,

            visible: column.visible,

            width: column.width || "",

            minWidth: "1px"

          };

        });

        window.localStorage.setItem(this.storageKey, JSON.stringify(payload));

      } catch (e) {

        // ignore

      }

    },

    loadColumnSettings() {

      try {

        const saved = window.localStorage.getItem(this.storageKey);

        if (!saved) {

          return;

        }

        const parsed = JSON.parse(saved);

        if (!Array.isArray(parsed) || !parsed.length) {

          return;

        }

        const mapped = [];

        parsed.forEach((savedColumn) => {

          const original = this.internalHeaders.find((x) => x.value === savedColumn.value);

          if (original) {

            mapped.push(

              Object.assign({}, original, {

                visible:

                  typeof savedColumn.visible === "boolean"

                    ? savedColumn.visible

                    : original.visible,

                width: savedColumn.width || original.width,

                minWidth: "1px"

              })

            );

          }

        });

        this.internalHeaders.forEach((column) => {

          if (!mapped.find((x) => x.value === column.value)) {

            mapped.push(

              Object.assign({}, column, {

                minWidth: "1px"

              })

            );

          }

        });

        this.internalHeaders = mapped;

      } catch (e) {

        // ignore

      }

    },

    resetColumns() {

      const reset = JSON.parse(JSON.stringify(this.defaultHeadersSnapshot)).map(function (column) {

        return Object.assign({}, column, {

          minWidth: "1px"

        });

      });

      this.internalHeaders = reset;

      this.saveColumnSettings();

      this.updateTopScrollbar();

    },

    getRowClass(item) {

      if (typeof this.rowClassFn === "function") {

        return this.rowClassFn(item);

      }

      return "";

    },

    getRowKey(item, index) {

      if (item && (item.id || item.ID || item.Id)) {

        return item.id || item.ID || item.Id;

      }

      if (item && item.PNR) {

        return item.PNR + "_" + index;

      }

      return index;

    }

  }

};

</script>

<style scoped>

.report-table-card {

  border-radius: 12px;

  overflow: visible;

}

.report-topbar {

  display: flex;

  align-items: center;

  justify-content: space-between;

  padding: 16px 0 12px 0;

  flex-wrap: wrap;

  gap: 12px;

}

.report-meta {

  display: flex;

  align-items: center;

  flex-wrap: wrap;

  gap: 20px;

  color: #78909c;

  font-size: 14px;

}

.meta-item strong {

  color: #37474f;

}

.report-actions {

  display: flex;

  gap: 10px;

  flex-wrap: wrap;

  align-items: center;

}

.toolbar-search {

  max-width: 280px;

}

.table-stage {

  position: relative;

  overflow: visible;

}

.report-scroll-top {

  overflow-x: auto;

  overflow-y: hidden;

  height: 12px;

  margin-bottom: 8px;

}

.report-scroll-inner {

  height: 1px;

}

.table-wrapper {

  width: 100%;

  border: 1px solid #e6ebf2;

  border-radius: 12px;

  background: #fff;

  overflow: auto;

}

.modern-report-table {

  width: max-content;

  min-width: 100%;

  border-collapse: separate;

  border-spacing: 0;

  table-layout: fixed;

}

.column-header {

  position: relative;

  background: #f8fafc;

  border-bottom: 1px solid #e6ebf2 !important;

  border-right: 1px solid #eef2f7;

  user-select: none;

  vertical-align: top;

  white-space: normal;

  word-break: break-word;

  overflow-wrap: anywhere;

  overflow: hidden;

  padding: 6px 22px 6px 4px;

  min-width: 0;

  max-width: 1px;

}

.column-header.sortable {

  cursor: pointer;

}

.header-content {

  display: block;

  min-height: 16px;

  min-width: 0;

  width: 100%;

  overflow: hidden;

}

.header-left {

  display: flex;

  align-items: flex-start;

  gap: 2px;

  min-width: 0;

  width: 100%;

  overflow: hidden;

}

.header-text {

  display: block;

  min-width: 0;

  flex: 1 1 auto;

  font-weight: 600;

  color: #37474f;

  white-space: normal;

  word-break: break-word;

  overflow-wrap: anywhere;

  line-height: 1.2;

  overflow: hidden;

}

.sort-icons {

  position: absolute;

  top: 6px;

  right: 10px;

  display: flex;

  align-items: center;

  justify-content: center;

  color: #1976d2;

  width: 12px;

  pointer-events: none;

}

.drag-handle {

  cursor: move;

  color: #90a4ae;

  font-size: 14px !important;

}

.header-drag-handle {

  flex: 0 0 12px;

  width: 12px;

  min-width: 12px;

  margin-top: 1px;

  margin-right: 2px;

}

.column-resizer {

  position: absolute;

  top: 0;

  right: -2px;

  width: 8px;

  height: 100%;

  cursor: col-resize;

  z-index: 6;

}

.column-resizer::after {

  content: "";

  position: absolute;

  top: 15%;

  right: 3px;

  width: 2px;

  height: 70%;

  background: #cfd8dc;

  border-radius: 2px;

  opacity: 0;

  transition: opacity 0.2s ease;

}

.column-header:hover .column-resizer::after,

.column-resizer:hover::after {

  opacity: 1;

}

.report-cell {

  border-bottom: 1px solid #edf2f7;

  border-right: 1px solid #f5f7fa;

  padding: 8px 4px;

  white-space: normal;

  word-break: break-word;

  overflow-wrap: anywhere;

  overflow: hidden;

  vertical-align: top;

  line-height: 1.45;

  background: #fff;

  min-width: 0;

  max-width: 1px;

}

.cell-content {

  display: block;

  width: 100%;

  min-width: 0;

  white-space: normal;

  word-break: break-word;

  overflow-wrap: anywhere;

}

.empty-state-cell {

  padding: 0;

}

.empty-state {

  padding: 24px 12px;

  text-align: center;

  color: #78909c;

  font-weight: 600;

}

.custom-pagination {

  display: flex;

  align-items: center;

  justify-content: space-between;

  gap: 16px;

  padding: 16px 4px 4px 4px;

  flex-wrap: wrap;

}

.pagination-left,

.pagination-center,

.pagination-right {

  display: flex;

  align-items: center;

  gap: 10px;

}

.rows-per-page-select {

  width: 110px;

}

.page-info {

  min-width: 110px;

  text-align: center;

  font-weight: 600;

  color: #546e7a;

}

.column-dialog-note {

  color: #90a4ae;

  margin-bottom: 14px;

  font-size: 13px;

}

.column-list {

  display: flex;

  flex-direction: column;

  gap: 10px;

}

.column-item {

  border: 1px solid #e3e8ef;

  border-radius: 10px;

  padding: 10px 14px;

  display: flex;

  align-items: center;

  justify-content: space-between;

  background: #fafbfd;

}

.column-item-left {

  display: flex;

  align-items: center;

  min-width: 0;

}

.column-title {

  font-weight: 600;

  color: #455a64;

}

.column-switch {

  margin-left: 12px;

}

.report-scroll-top::-webkit-scrollbar,

.table-wrapper::-webkit-scrollbar {

  height: 12px;

}

.report-scroll-top::-webkit-scrollbar-track,

.table-wrapper::-webkit-scrollbar-track {

  background: #edf2f7;

  border-radius: 10px;

}

.report-scroll-top::-webkit-scrollbar-thumb,

.table-wrapper::-webkit-scrollbar-thumb {

  background: #9e9e9e;

  border-radius: 10px;

}

.report-scroll-top::-webkit-scrollbar-thumb:hover,

.table-wrapper::-webkit-scrollbar-thumb:hover {

  background: #7f8c8d;

}


.export-processing-card { overflow: hidden; }
.export-processing-title { font-weight: 600; color: #37474f; }
.export-processing-body { display: flex; align-items: flex-start; gap: 18px; padding: 24px !important; }
.export-processing-icon { flex: 0 0 auto; padding-top: 2px; }
.export-processing-content { flex: 1 1 auto; min-width: 0; }
.export-processing-main-text { color: #37474f; font-size: 15px; font-weight: 600; line-height: 1.5; }
.export-processing-note { margin-top: 7px; color: #78909c; font-size: 12px; line-height: 1.45; }
.export-progress-row { display:flex; align-items:center; gap:12px; margin-top:18px; }
.export-progress-percent { flex:0 0 44px; color:#1565c0; font-size:13px; font-weight:700; text-align:right; }

.export-processing-bar { flex: 1 1 auto; margin-top: 0; border-radius: 10px; overflow: hidden; }

@media (max-width: 960px) {

  .report-topbar {

    flex-direction: column;

    align-items: stretch;

  }

  .report-actions {

    justify-content: flex-start;

  }

  .custom-pagination {

    flex-direction: column;

    align-items: flex-start;

  }

  .toolbar-search {

    max-width: 100%;

  }

}

</style>

<style>

body.report-table-resizing {

  cursor: col-resize !important;

  user-select: none !important;

}

</style>